import { CollectionContainer, headingTags } from '@atlassian/amkt-common';
import { ScreenClass } from '@atlassian/mpac-types';
import { UrlUtils } from '@atlassian/mpac-utils';
import React from 'react';

import SolutionsConfig from 'app/records/SolutionsConfig';
import CategoryTile from './CategoryTile';

import type { CategoryTileSetType } from '../../records/CategoryTileSet';

import styles from './CategoryTilesPanel.less';

type CategoryTilesPanelPropTypes = {
  categoryTileSet: CategoryTileSetType;
  onCategoryTileClick: () => void;
  screenClass: ScreenClass;
  solutionsConfig: SolutionsConfig;
};

const CategoryTilesPanel = (props: CategoryTilesPanelPropTypes) => {
  const categoryTiles = props.categoryTileSet.categoryTiles?.resolveItems(
    props.screenClass === 'sm' ? 2 : 3
  );

  return (
    <div className={styles.categoryTilesPanel}>
      <CollectionContainer
        description={props.categoryTileSet.tagline}
        descriptionClassName={styles.categoryTilesPanelDescription}
        headingClassName={styles.categoryTilesPanelHeading}
        headingText={props.categoryTileSet.heading}
        headingTag={headingTags.H2}
      >
        <div className={styles.categoryTilesContainer}>
          {categoryTiles?.map((ct) => (
            <CategoryTile
              categoryTile={ct}
              key={ct.key}
              href={UrlUtils.resolveUrlFromTemplateAndParameters({
                template: props.solutionsConfig.links.solution.href,
                parameters: { category: ct.key },
              })}
              onClick={props.onCategoryTileClick}
              screenClass={props.screenClass}
            />
          ))}
        </div>
      </CollectionContainer>
    </div>
  );
};

export default CategoryTilesPanel;
